import GoalTemplatesLibrary from '@components/libraries/GoalTemplatesLibrary';
import ExpertJourneyPage from '@components/pageTypes/ExpertJourneyPage';

type Props = {
  journeyId: string;
};

const ExpertJourneyGoalTemplatesPage = ({ journeyId }: Props) => (
  <ExpertJourneyPage helmetKey="pageTitles.expertJourney.goalTemplate.list" journeyId={journeyId}>
    <GoalTemplatesLibrary journeyId={journeyId} />
  </ExpertJourneyPage>
);

export default ExpertJourneyGoalTemplatesPage;
